@for (val of displayTags | slice: 0 : showCount; track $index) {
    <vc-badge
        class="space-4"
        [tooltipPosition]="tooltipPosition"
        [tooltip]="val.displayValue"
        [prefixIcon]="val.prefix | tagIcon"
        [label]="val.displayValue"></vc-badge>
}
@if (displayTags.length > showCount) {
    <vc-badge
        class="space-4 vc-tags-count"
        label="+{{ displayTags.length - showCount }}"
        [showTooltip]="true"
        [tooltip]="notVisibleTagsTooltip"
        [tooltipPosition]="tooltipPosition"></vc-badge>
}
